import { StatusCode } from "../components/statuses/store/slice";

export const getStatusColor = (code: StatusCode) => {
  let color = "primary";

  switch (code) {
    case StatusCode.Pending:
      color = "secondary";
      break;
    case StatusCode.PendingChange:
      color = "secondary";
      break;
    case StatusCode.PendingCancellation:
      color = "secondary";
      break;
    case StatusCode.WaitingList:
      color = "secondary";
      break;
    case StatusCode.Confirmed:
      color = "success";
      break;
    case StatusCode.Cancelled:
      color = "danger";
      break;
    case StatusCode.CheckedIn:
      color = "success";
      break;
    case StatusCode.NoShow:
      color = "success";
      break;
    case StatusCode.LateCancellation:
      color = "danger";
      break;
    case StatusCode.Issued:
      color = "success";
      break;
    case StatusCode.NotIssued:
      color = "secondary";
      break;
  }

  return color;
};
